import { Component } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { TranslateHelper } from '../../../../helpers/injector.helper';
import { TaskRegistryEntry, TaskType } from '../../../../helpers/task.registry';
import { CellStyle } from '../../../../models/styling/cell.style';
import { LevelHeaderFormattingTaskExecuter } from '../../../../models/tasks/formattasks/levelheader.formatting.task';
import { TaskHelper } from '../../../../models/tasks/task.helper';
import { ALevelPanel, ALevelTaskSettingsHelper } from '../../a.task.panel';

@Component({
    selector: 'levelheader-formatting-task-panel',
    templateUrl: './levelheader.formatting.task.panel.html'
})
export class LevelHeaderFormattingTaskPanel extends ALevelPanel {

    static GetRegistry(): TaskRegistryEntry {
        const reg = new TaskRegistryEntry();
        reg.ID = LevelHeaderFormattingTaskExecuter.TaskID;
        reg.Caption = '@@Levelkopf';
        reg.SettingsControl = LevelHeaderFormattingTaskPanel;
        reg.SettingsHelper = new LevelHeaderFormattingTaskSettingsHelper();
        reg.Executer = LevelHeaderFormattingTaskExecuter;
        reg.TaskType = TaskType.FormatTask;
        return reg;
    }

    OnSettingsSet() {
        if (this.SettingsValue) {
            if (this.SettingsValue.Style) {
                if (!(this.SettingsValue.Style instanceof CellStyle)) {
                    this.SettingsValue.Style = plainToInstance(CellStyle, this.SettingsValue.Style);
                }
            } else {
                this.SettingsValue.Style = new CellStyle();
            }
        }
    }    
}

export class LevelHeaderFormattingTaskSettingsHelper extends ALevelTaskSettingsHelper {
    canExecute(reportObject: any): boolean {
        return TaskHelper.IsTableObject(reportObject);
    }
    getCaption(task: any, dd: any) {
        const caption = super.getCaption(task, dd);
        if (caption) {
            return caption + " - " + TranslateHelper.TranslatorInstance.instant('@@Levelkopfformatierung');
        }
        return TranslateHelper.TranslatorInstance.instant('@@Levelkopfformatierung');
    }
}
